"use client";

import { useState } from "react";

/**
 * What actually happens to what people upload and record.
 *
 * The project's legal position is a design decision, not a disclaimer
 * (spec §10): packs never leave the room that made them, so there is no
 * organised public library — and the dub, unlike the source clip, is the
 * players' own work. Saying that plainly is both honest and the thing that
 * makes the rules feel like rules rather than fine print.
 */
export function LegalNote() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="cursor-pointer text-xs font-bold uppercase tracking-[0.12em] text-ink-faint underline decoration-2 underline-offset-4 transition-colors hover:text-ink-soft focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-sky"
      >
        Права и правила
      </button>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Права и правила"
          className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-[#0b0e22]/80 p-4 py-6 backdrop-blur-sm sm:items-center"
          onKeyDown={(event) => {
            if (event.key === "Escape") setOpen(false);
          }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setOpen(false);
          }}
        >
          <div className="sticker w-full max-w-lg rounded-3xl border-4 border-outline bg-card p-6">
            <h2 className="font-display text-xl font-extrabold tracking-tight text-ink">
              Права и правила
            </h2>

            <dl className="mt-4 flex flex-col gap-3.5 text-sm leading-relaxed text-ink-soft">
              <div>
                <dt className="font-display font-extrabold text-ink">Паки живут в комнате</dt>
                <dd>
                  Общей витрины нет и не будет. Загруженный пак виден только тем, кто в этой
                  комнате, и удаляется вместе с ней — сразу, когда все вышли, или через час
                  тишины. Крестик на карточке убирает пак немедленно.
                </dd>
              </div>

              <div>
                <dt className="font-display font-extrabold text-ink">Дубляж — ваш</dt>
                <dd>
                  Ваши записи — ваша работа: пародия и пастиш защищены отдельно от исходного
                  ролика. Экспорт раунда можно скачать и выкладывать где хотите.
                </dd>
              </div>

              <div>
                <dt className="font-display font-extrabold text-ink">За материал отвечает тот, кто его принёс</dt>
                <dd>
                  Загружая пак, вы подтверждаете, что имеете на это право, и указываете
                  происхождение. Мы храним это как факт — и ничьё чужое видео у себя не
                  публикуем.
                </dd>
              </div>

              <div>
                <dt className="font-display font-extrabold text-ink">Что мы храним</dt>
                <dd>
                  Только то, без чего игра не работает: имя, выбранного зверя, записи раунда и
                  загруженные паки. Ни почты, ни паролей, ни аналитики. Всё уходит вместе с
                  комнатой.
                </dd>
              </div>
            </dl>

            <button
              type="button"
              onClick={() => setOpen(false)}
              className="press sticker-sm mt-5 w-full cursor-pointer rounded-2xl border-4 border-outline bg-sky px-4 py-3 font-display text-sm font-bold text-ink focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-sky"
            >
              Понятно
            </button>
          </div>
        </div>
      )}
    </>
  );
}
